import React, { useEffect } from 'react';
import { SuccessPage } from './SuccessPage';
import { useNavigate } from 'react-router-dom';
import { Loading } from '../Loading';

export type ErrorPageProps = {
  outRoles?: boolean;
  errorCode?: number;
};

export const ErrorPage: React.FC<ErrorPageProps> = (props: ErrorPageProps) => {
  const navigate = useNavigate();
  const { errorCode } = props;
  const goBack = (): void => {
    navigate(-1);
  };

  if (errorCode === 0) {
    window.location.href = '/login';
  }
  const [loading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, []);

  const notFound = (
    <SuccessPage
      icon="failed"
      title={`Ah, snap!`}
      action={
        <div className="ml-6">
          <h2 className="mb-4">
            There seems to be nothing available here. If you have any questions
            about this page, please contact our support team at{' '}
            <a>gs.it@polyu.edu.hk</a> for assistance.
          </h2>
          <a href="/" className="btn btn-primary cursor-pointer">
            Back to homepage
          </a>
        </div>
      }
    />
  );

  const notAuthorized = loading ? (
    <Loading />
  ) : (
    <SuccessPage
      icon="failed"
      title={`Ah, snap! `}
      action={
        <div className="ml-6">
          <h2 className="my-2">
            It appears that you do not have the necessary permissions to access
            this page. Please check your current role.
          </h2>
          <h2 className="mb-4">
            If you have any questions or require further assistance, please
            contact our support team at <a>gs.it@polyu.edu.hk</a> for
            assistance.
          </h2>
          <a onClick={goBack} className="btn btn-primary cursor-pointer">
            Go back
          </a>
        </div>
      }
    />
  );

  const displayMap = new Map<number, React.ReactNode>([
    [403, notAuthorized],
    [404, notFound],
    [200, notFound],
  ]);

  return (
    <div style={{ padding: '4rem' }}>{displayMap.get(errorCode ?? 404)}</div>
  );
};
